import { compose, filter, flatten, groupBy, map, prop, values } from 'ramda';

import { joinString } from './string';

export const toUsersWithLogin = (user) => {
	const login = user.login ? `- ${user.login}` : null;

	return {
		...user,
		fullName: `${user.surname || ''} ${user.firstName || ''} ${login || ''}`.trim(),
	};
};

/**
 * This will verify, that login consists of domain part (only letters),
 * exactly one backslash and username (only alphanumeric characters or underscore).
 *
 * @param login
 */
export const isUserLoginFormat = (login) => /^[A-Za-z]+\\\w+/.test(login);

export const generateFullname = (surname, firstName) => {
	return joinString(' ', [surname, firstName]);
};

// sellerRequest, addTaskVias, ... generating codelist options
// where logins are append to fullnames, in case of multiple same fullnames
export const userCodelistOptionsWithFullnamesAndLogins = compose(
	flatten,
	values,
	map((user) => {
		if (user.length > 1) {
			return user.map((option) => {
				return {
					name: `${option.fullname} - ${option.login}`,
					code: option.login,
				};
			});
		} else {
			return {
				name: user[0].fullname,
				code: user[0].login,
			};
		}
	}),
	groupBy(prop('fullname')),
	map((user) => {
		return {
			...user,
			fullname: generateFullname(user.surname, user.firstName),
		};
	}),

	filter(({ login }) => isUserLoginFormat(login)),
);
